<template>
    <div>
        <Row :gutter="20">
            <Col :xs="24" :sm="12" :md="8" :lg="4" v-for="(infor, i) in inforCardData" :key="`infor-${i}`"
                 style="height: 120px;padding-bottom: 10px;">
                <infor-card :shadow="false" :color="infor.color" :icon="infor.icon" :icon-size="36">
                    <count-to :end="infor.count" count-class="count-style"/>
                    <p>{{ infor.title }}</p>
                </infor-card>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col :xs="24" :sm="5" :md="5" :lg="5" style="margin-top: 10px;">
                <Card>
                    <div style="text-align:center;">
                        <img :src="getAvatar" class="upload_img" style="width:95%;height:95%;"/>
                    </div>
                    <Input type="text" v-model.trim="getName" style="margin-top:8px;" readonly>
                        <Icon type="ios-person-outline" slot="prepend"></Icon>
                    </Input>
                    <Input type="text" v-model.trim="getEmail" style="margin-top:7px;" readonly>
                        <Icon type="md-mail" slot="prepend"></Icon>
                    </Input>
                    <Input type="text" v-model.trim="getMobile" style="margin-top:7px;" readonly>
                        <Icon type="md-phone-portrait" slot="prepend"></Icon>
                    </Input>
                    <!--首页用户编辑按钮去除-->
                    <!--<div style="text-align:right;margin-top:8px;">
                        <Button type="primary" size="small" icon="ios-create-outline" @click="editHandleClick">
                            {{msgUtil.message.action.edit}}
                        </Button>
                    </div>-->
                </Card>
            </Col>
            <Col :xs="24" :sm="9" :md="9" :lg="9" style="margin-top: 10px;">
                <Card>
                    <Table size="small" :show-header="false" :columns="tableColumn" :data="getTableLeftData"></Table>
                </Card>
            </Col>
            <Col :xs="24" :sm="10" :md="10" :lg="10" style="margin-top: 10px;">
                <Card>
                    <Table size="small" :show-header="false" :columns="tableColumn" :data="getTableRightData"></Table>
                </Card>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col :xs="24" :sm="8" :md="8" :lg="8" style="margin-top: 20px;">
                <Card>
                    <!--<chart-pie ref="chartPie" style="height: 300px;" :value="pieData" :text="t.adAccessFrom"></chart-pie>-->
                    <div ref="dom1" style="height: 300px;" class="charts chart-pie"></div>
                </Card>
            </Col>
            <Col :xs="24" :sm="16" :md="16" :lg="16" style="margin-top: 20px;">
                <Card>
                    <!--<chart-bar ref="chartBar" style="height: 300px;" :value="barData" :text="t.userActiveDegree"/>-->
                    <div ref="dom2" style="height: 300px;" class="charts chart-bar"></div>
                </Card>
            </Col>
        </Row>
        <Row style="margin-top: 20px;">
            <Card>
                <div ref="dom3" style="height: 310px;"></div>
            </Card>
        </Row>
    </div>
</template>

<script>
import InforCard from '@/components/info-card';
import CountTo from '@/components/count-to';
import { ChartBar, ChartPie } from '@/components/charts';
import echarts from 'echarts';
import { off, on } from '@/libs/tools';
import { getHome } from '@/api/home';

export default {
    name: 'home',
    components: {
        InforCard,
        CountTo,
        ChartPie,
        ChartBar,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            t: t,
            msgUtil: msgUtil,
            dom: null,
            systemInfo: {
                systemName: '',
                systemVersion: '',
                osName: '',
                osVersion: '',
                osArch: '',
                cpuCoreCount: '',
                memoryTotal: '',
                memoryFree: '',
                memoryUsedPercent: '',
                localeLanguage: '',
                jvmName: '',
                jvmVersion: '',
                jvmHome: '',
                userDir: '',
                jvmMaxMemory: '',
                jvmFreeMemory: '',
                jvmTotalMemory: '',
                userName: '',
                cpuCombinedPercent: '',
                zone: '',
            },
            tableColumn: [
                {
                    title: 'Name',
                    key: 'name',
                    width: 120,
                    tooltip: true,
                },
                {
                    title: 'Content',
                    key: 'content',
                    tooltip: true,
                },
            ],
            inforCardData: [
                { title: t.card.user, icon: 'md-people', count: 0, color: '#2d8cf0' },
                { title: t.card.ad, icon: 'md-pin', count: 0, color: '#ed3f14' },
                { title: t.card.article, icon: 'md-paper', count: 0, color: '#19be6b' },
                { title: t.card.picture, icon: 'md-photos', count: 0, color: '#E46CBB' },
                { title: t.card.tag, icon: 'md-pricetags', count: 0, color: '#ff9900' },
                { title: t.card.journal, icon: 'md-paper-plane', count: 0, color: '#9A66E4' },
            ],
            /*pieData: [
                            { value: 335, name: t.region.hokaido },
                            { value: 348, name: t.region.touhoku },
                            { value: 788, name: t.region.kanntou },
                            { value: 217, name: t.region.tyubu },
                            { value: 103, name: t.region.kinki },
                            { value: 188, name: t.region.tyugoku },
                            { value: 979, name: t.region.sikoku },
                            { value: 262, name: t.region.kyuusyuu },
                            { value: 496, name: t.region.okinawaken },
                            { value: 2018, name: t.region.kaigai },
                        ],*/
            pieData: [
                { value: 0, name: '' },
                { value: 0, name: '' },
                { value: 0, name: '' },
                { value: 0, name: '' },
                { value: 0, name: '' },
            ],
            barData: {
                Mon: 13253,
                Tue: 34235,
                Wed: 26321,
                Thu: 12340,
                Fri: 24643,
                Sat: 1322,
                Sun: 1324,
            },
        };
    },
    methods: {
        resize() {
            this.dom1.resize();
            this.dom2.resize();
            this.dom3.resize();
        },
        resize1() {
            this.dom1.resize();
        },
        resize2() {
            this.dom2.resize();
        },
        resize3() {
            this.dom3.resize();
        },
        editHandleClick() {
            this.$router.push({
                name: 'my_info',
            });
        },
    },
    computed: {
        getName() {
            return this.$store.state.user.myInfo.name;
        },
        getEmail() {
            return this.$store.state.user.myInfo.email;
        },
        getMobile() {
            return this.$store.state.user.myInfo.mobile;
        },
        getAvatar() {
            return this.$store.state.user.myInfo.avatar;
        },
        getTableLeftData() {
            return [
                {
                    name: this.t.systemInfo.systemName,
                    content: this.systemInfo.systemName,
                },
                {
                    name: this.t.systemInfo.systemVersion,
                    content: this.systemInfo.systemVersion,
                },
                {
                    name: this.t.systemInfo.osName,
                    content: this.systemInfo.osName,
                },
                {
                    name: this.t.systemInfo.osVersion,
                    content: this.systemInfo.osVersion,
                },
                {
                    name: this.t.systemInfo.osArch,
                    content: this.systemInfo.osArch,
                },
                {
                    name: this.t.systemInfo.cpuCoreCount,
                    content: this.systemInfo.cpuCoreCount,
                },
                {
                    name: this.t.systemInfo.memoryTotal,
                    content: this.systemInfo.memoryTotal,
                },
                {
                    name: this.t.systemInfo.memoryFree,
                    content: this.systemInfo.memoryFree,
                },
                {
                    name: this.t.systemInfo.memoryUsedPercent,
                    content: this.systemInfo.memoryUsedPercent,
                },
                {
                    name: this.t.systemInfo.localeLanguage,
                    content: this.systemInfo.localeLanguage,
                },
            ];
        },
        getTableRightData() {
            return [
                {
                    name: this.t.systemInfo.jvmName,
                    content: this.systemInfo.jvmName,
                },
                {
                    name: this.t.systemInfo.jvmHome,
                    content: this.systemInfo.jvmHome,
                },
                {
                    name: this.t.systemInfo.jvmVersion,
                    content: this.systemInfo.jvmVersion,
                },
                {
                    name: this.t.systemInfo.userDir,
                    content: this.systemInfo.userDir,
                },
                {
                    name: this.t.systemInfo.jvmTotalMemory,
                    content: this.systemInfo.jvmTotalMemory,
                },
                {
                    name: this.t.systemInfo.jvmFreeMemory,
                    content: this.systemInfo.jvmFreeMemory,
                },
                {
                    name: this.t.systemInfo.jvmMaxMemory,
                    content: this.systemInfo.jvmMaxMemory,
                },
                {
                    name: this.t.systemInfo.userName,
                    content: this.systemInfo.userName,
                },
                {
                    name: this.t.systemInfo.cpuCombinedPercent,
                    content: this.systemInfo.cpuCombinedPercent,
                },
                {
                    name: this.t.systemInfo.zone,
                    content: this.systemInfo.zone,
                },
            ];
        },
    },
    async mounted() {},
    async created() {
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985',
                    },
                },
            },
            grid: {
                top: '3%',
                left: '1.2%',
                right: '1%',
                bottom: '3%',
                containLabel: true,
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: [
                        this.t.date.mon,
                        this.t.date.tue,
                        this.t.date.wed,
                        this.t.date.thu,
                        this.t.date.fri,
                        this.t.date.sat,
                        this.t.date.sun,
                    ],
                },
            ],
            yAxis: [
                {
                    type: 'value',
                },
            ],
            series: [
                {
                    name: this.t.log.accessLog + '-' + this.t.log.normal,
                    type: 'line',
                    stack: this.t.log.normal,
                    areaStyle: {
                        normal: {
                            color: '#2d8cf0',
                        },
                    },
                    data: [120, 132, 101, 134, 90, 230, 210],
                },
                {
                    name: this.t.log.accessLog + '-' + this.t.log.error,
                    type: 'line',
                    stack: this.t.log.error,
                    areaStyle: {
                        normal: {
                            color: '#10A6FF',
                        },
                    },
                    data: [257, 358, 278, 234, 290, 330, 310],
                },
                {
                    name: this.t.log.operLog + '-' + this.t.log.normal,
                    type: 'line',
                    stack: this.t.log.normal,
                    areaStyle: {
                        normal: {
                            color: '#0C17A6',
                        },
                    },
                    data: [379, 268, 354, 269, 310, 478, 358],
                },
                {
                    name: this.t.log.operLog + '-' + this.t.log.error,
                    type: 'line',
                    stack: this.t.log.error,
                    areaStyle: {
                        normal: {
                            color: '#4608A6',
                            //color: '#398DBF'
                        },
                    },
                    data: [320, 332, 301, 334, 390, 330, 320],
                },
            ],
        };
        const result = await getHome();

        if (result != null) {
            //部署系统的信息
            this.systemInfo = result.systemInfo;
            //用户总件数
            this.inforCardData[0].count = result.userCount;
            //广告总件数
            this.inforCardData[1].count = result.adCount;
            //文章总件数
            this.inforCardData[2].count = result.articleCount;
            //this.inforCardData[3].count = result.articleHits;
            //图片总件数
            this.inforCardData[3].count = result.pictureCount;
            // this.inforCardData[5].count = result.pictureHits;
            //标签总件数
            this.inforCardData[4].count = result.tagCount;
            //刊物总件数
            this.inforCardData[5].count = result.journalCount;

            //每个广告位对应的广告件数
            this.pieData[0].name = result.adSpaceActiveDegree[0].k;
            this.pieData[0].value = result.adSpaceActiveDegree[0].count;
            this.pieData[1].name = result.adSpaceActiveDegree[1].k;
            this.pieData[1].value = result.adSpaceActiveDegree[1].count;
            this.pieData[2].name = result.adSpaceActiveDegree[2].k;
            this.pieData[2].value = result.adSpaceActiveDegree[2].count;
            this.pieData[3].name = result.adSpaceActiveDegree[3].k;
            this.pieData[3].value = result.adSpaceActiveDegree[3].count;
            this.pieData[4].name = result.adSpaceActiveDegree[4].k;
            this.pieData[4].value = result.adSpaceActiveDegree[4].count;
            //文章件数(先週)
            this.barData.Mon = result.articleActiveDegree[0];
            this.barData.Tue = result.articleActiveDegree[1];
            this.barData.Wed = result.articleActiveDegree[2];
            this.barData.Thu = result.articleActiveDegree[3];
            this.barData.Fri = result.articleActiveDegree[4];
            this.barData.Sat = result.articleActiveDegree[5];
            this.barData.Sun = result.articleActiveDegree[6];

            //前一周的log成功失败的每天的件数统计
            option.series[0].data = result.logActiveDegree[0];
            option.series[1].data = result.logActiveDegree[1];
            option.series[2].data = result.logActiveDegree[2];
            option.series[3].data = result.logActiveDegree[3];

            this.$nextTick(() => {
                let legend = this.pieData.map(_ => _.name);
                //console.log(legend);
                let option = {
                    title: {
                        text: this.t.adCount,
                        subtext: '',
                        x: 'center',
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)',
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: legend,
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '60%'],
                            data: this.pieData,
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                                },
                            },
                        },
                    ],
                };
                this.dom1 = echarts.init(this.$refs.dom1, 'tdTheme');
                this.dom1.setOption(option);
                on(window, 'resize', this.resize1);
            });

            this.$nextTick(() => {
                let xAxisData = Object.keys(this.barData);
                let seriesData = Object.values(this.barData);
                let option = {
                    title: {
                        text: this.t.articleCreateCount,
                        subtext: '',
                        x: 'center',
                    },
                    xAxis: {
                        type: 'category',
                        data: xAxisData,
                    },
                    yAxis: {
                        type: 'value',
                    },
                    series: [
                        {
                            data: seriesData,
                            type: 'bar',
                        },
                    ],
                };
                this.dom2 = echarts.init(this.$refs.dom2, 'tdTheme');
                this.dom2.setOption(option);
                on(window, 'resize', this.resize2);
            });

            this.$nextTick(() => {
                this.dom3 = echarts.init(this.$refs.dom3);
                this.dom3.setOption(option);
                on(window, 'resize', this.resize3);
            });
        }
        //console.log(result);
    },
    beforeDestroy() {
        off(window, 'resize', this.resize);
    },
};
</script>

<style lang="less">
.count-style {
    font-size: 26px;
}
</style>
